import FJConfig from '../FJConfig';

export const STYLE_LIST = [
    {
        categoryName: 'hot',
        list: [
            {
                uniqueKey: 'hot-ghibli-1',
                name: 'ghibli-1',
                value: 'ghibli-1',
                img: 'ghibli-1.png',
                buryName: 'Ghibli-1',
                isNew: true,
            },
            {
                uniqueKey: 'hot-ghibli-2',
                name: 'ghibli-2',
                value: 'ghibli-2',
                img: 'ghibli-2.png',
                buryName: 'Ghibli-2',
                isNew: true,
            },
            {
                uniqueKey: 'hot-action-figure-1',
                name: 'action-figure-1',
                value: 'action-figure-1',
                img: 'action-figure-1.png',
                buryName: 'Action Figure 1',
                isNew: true,
            },
            {
                uniqueKey: 'hot-purple-american-comic',
                name: 'purple-american-comic',
                value: 'purple-american-comic',
                img: 'purple-american-comic.png',
                buryName: 'Purple Comic',
            },
            {
                uniqueKey: 'hot-color-sketch',
                name: 'color-sketch',
                value: 'color-sketch',
                img: 'color-sketch.png',
                buryName: 'Color Sketch',
            },
            {
                uniqueKey: 'hot-felt',
                name: 'felt',
                value: 'felt',
                img: 'felt.png',
                buryName: 'Felt',
            },
            {
                uniqueKey: 'hot-picture-book-2',
                name: 'picture-book-2',
                value: 'picture-book-2',
                img: 'picture-book-2.png',
                buryName: 'Picture Book 2',
            },
            {
                uniqueKey: 'hot-cute-vector',
                name: 'cute-vector',
                value: 'cute-vector',
                img: 'cute-vector.png',
                buryName: 'Cute Vector',
            },
        ],
    },
    {
        categoryName: 'action-figure',
        list: [
            {
                uniqueKey: 'action-figure-action-figure-1',
                name: 'action-figure-1',
                value: 'action-figure-1',
                img: 'action-figure-1.png',
                buryName: 'Action Figure 1',
                isNew: true,
            },
            {
                uniqueKey: 'action-figure-action-figure-2',
                name: 'action-figure-2',
                value: 'action-figure-2',
                img: 'action-figure-2.png',
                buryName: 'Action Figure 2',
                isNew: true,
            },
            {
                uniqueKey: 'action-figure-barbie',
                name: 'barbie',
                value: 'barbie',
                img: 'barbie.png',
                buryName: 'Barbie',
            },
            {
                uniqueKey: 'action-figure-pink',
                name: 'pink',
                value: 'pink',
                img: 'pink.png',
                buryName: 'Pink',
            },
            {
                uniqueKey: 'action-figure-business',
                name: 'business',
                value: 'business',
                img: 'business.png',
                buryName: 'Business',
            },
            {
                uniqueKey: 'action-figure-football',
                name: 'football',
                value: 'football',
                img: 'football.png',
                buryName: 'Football',
            },
            {
                uniqueKey: 'action-figure-dj',
                name: 'dj',
                value: 'dj',
                img: 'dj.png',
                buryName: 'DJ',
            },
            {
                uniqueKey: 'action-figure-skateboard',
                name: 'skateboard',
                value: 'skateboard',
                img: 'skateboard.png',
                buryName: 'Skateboard',
            },
            {
                uniqueKey: 'action-figure-baby',
                name: 'baby',
                value: 'baby',
                img: 'baby.png',
                buryName: 'Baby',
            },
            {
                uniqueKey: 'action-figure-bald',
                name: 'bald',
                value: 'bald',
                img: 'bald.png',
                buryName: 'Bald',
            },
        ],
    },
    {
        categoryName: 'anime',
        list: [
            {
                uniqueKey: 'anime-green-art',
                name: 'green-art',
                value: 'green-art',
                img: 'green-art.png',
                buryName: 'Green Art',
            },
            {
                uniqueKey: 'anime-purple-american-comic',
                name: 'purple-american-comic',
                value: 'purple-american-comic',
                img: 'purple-american-comic.png',
                buryName: 'Purple Comic',
            },
            {
                uniqueKey: 'anime-vintage-2d-illustration',
                name: 'vintage-2d-illustration',
                value: 'vintage-2d-illustration',
                img: 'vintage-2d-illustration.png',
                buryName: 'Vintage 2D',
            },
            {
                uniqueKey: 'anime-claymation',
                name: 'claymation',
                value: 'claymation',
                img: 'claymation.png',
                buryName: 'Claymation',
            },
            {
                uniqueKey: 'anime-ghibli-1',
                name: 'ghibli-1',
                value: 'ghibli-1',
                img: 'ghibli-1.png',
                buryName: 'Ghibli-1',
                isNew: true,
            },
            {
                uniqueKey: 'anime-ghibli-2',
                name: 'ghibli-2',
                value: 'ghibli-2',
                img: 'ghibli-2.png',
                buryName: 'Ghibli-2',
                isNew: true,
            },
            {
                uniqueKey: 'anime-ghibli-3',
                name: 'ghibli-3',
                value: 'ghibli-3',
                img: 'ghibli-3.png',
                buryName: 'Ghibli-3',
            },
            {
                uniqueKey: 'anime-felt',
                name: 'felt',
                value: 'felt',
                img: 'felt.png',
                buryName: 'Felt',
            },
            {
                uniqueKey: 'anime-2d-vector-art',
                name: '2d-vector-art',
                value: '2d-vector-art',
                img: '2d-vector-art.png',
                buryName: '2D Vector',
            },
            {
                uniqueKey: 'anime-vector-illustration',
                name: 'vector-illustration',
                value: 'vector-illustration',
                img: 'vector-illustration.png',
                buryName: 'Vector',
            },
            {
                uniqueKey: 'anime-retro-anime',
                name: 'retro-anime',
                value: 'retro-anime',
                img: 'retro-anime.png',
                buryName: 'Retro Anime',
            },
            {
                uniqueKey: 'anime-enchanted-comic-fantasy',
                name: 'enchanted-comic-fantasy',
                value: 'enchanted-comic-fantasy',
                img: 'enchanted-comic-fantasy.png',
                buryName: 'Comic Fantasy',
            },

            {
                uniqueKey: 'anime-cute-vector',
                name: 'cute-vector',
                value: 'cute-vector',
                img: 'cute-vector.png',
                buryName: 'Cute Vector',
            },
        ],
    },

    {
        categoryName: 'painting',
        list: [
            {
                uniqueKey: 'painting-watercolor-1',
                name: 'watercolor-1',
                value: 'watercolor-1',
                img: 'watercolor-1.png',
                buryName: 'Watercolor 1',
            },
            {
                uniqueKey: 'painting-red-toned-oil-painting',
                name: 'red-toned-oil-painting',
                value: 'red-toned-oil-painting',
                img: 'red-toned-oil-painting.png',
                buryName: 'Oil Painting 1',
            },
            {
                uniqueKey: 'painting-color-sketch',
                name: 'color-sketch',
                value: 'color-sketch',
                img: 'color-sketch.png',
                buryName: 'Color Sketch',
            },
            {
                uniqueKey: 'painting-brown-watercolor',
                name: 'brown-watercolor',
                value: 'brown-watercolor',
                img: 'brown-watercolor.png',
                buryName: 'Watercolor 2',
            },
            {
                uniqueKey: 'painting-artsy',
                name: 'artsy',
                value: 'artsy',
                img: 'artsy.png',
                buryName: 'Artsy',
            },
            {
                uniqueKey: 'painting-pink-hand-drawn-art',
                name: 'pink-hand-drawn-art',
                value: 'pink-hand-drawn-art',
                img: 'pink-hand-drawn-art.png',
                buryName: 'Pink Sketch',
            },
            {
                uniqueKey: 'painting-vibrant-fluid-portrait',
                name: 'vibrant-fluid-portrait',
                value: 'vibrant-fluid-portrait',
                img: 'vibrant-fluid-portrait.png',
                buryName: 'Fluid Portrait',
            },
            {
                uniqueKey: 'painting-picture-book-1',
                name: 'picture-book-1',
                value: "children's-picture-book",
                img: 'children-s-picture-book.png',
                buryName: 'Picture Book 1',
            },
            {
                uniqueKey: 'painting-picture-book-2',
                name: 'picture-book-2',
                value: 'picture-book-2',
                img: 'picture-book-2.png',
                buryName: 'Picture Book 2',
            },
            {
                uniqueKey: 'painting-monochrome-sketch',
                name: 'monochrome-sketch',
                value: 'monochrome-sketch',
                img: 'monochrome-sketch.png',
                buryName: 'Mono Sketch',
            },
            {
                uniqueKey: 'painting-pencil-sketch',
                name: 'pencil-sketch',
                value: 'pencil-sketch',
                img: 'pencil-sketch.png',
                buryName: 'Pencil Sketch',
            },
            {
                uniqueKey: 'painting-oil-painting',
                name: 'oil-painting',
                value: 'oil-painting',
                img: 'oil-painting.png',
                buryName: 'Oil Painting 2',
            },
            {
                uniqueKey: 'painting-manga-art',
                name: 'manga-art',
                value: 'manga-art',
                img: 'manga-art.png',
                buryName: 'Manga Art',
            },
        ],
    },
    {
        categoryName: '3d',
        list: [
            {
                uniqueKey: '3d-fantasy-cgi',
                name: 'fantasy-cgi',
                value: 'fantasy-cgi',
                img: 'fantasy-cgi.png',
                buryName: 'Fantasy CGI',
            },
            {
                uniqueKey: '3d-pink-and-blue',
                name: '3d-pink-and-blue',
                value: '3d-pink-and-blue',
                img: '3d-pink-and-blue.png',
                buryName: 'Dreamy 3D',
            },
            {
                uniqueKey: '3d-tranquil-3d',
                name: 'tranquil-3d',
                value: 'tranquil-3d',
                img: 'tranquil-3d.png',
                buryName: '3D Cartoon',
            },
            {
                uniqueKey: '3d-pastel-3d',
                name: 'blue-3d',
                value: 'blue-3d',
                img: 'pastel-3d.png',
                buryName: 'Pastel 3D',
            },
            {
                uniqueKey: '3d-orange',
                name: 'orange',
                value: 'orange',
                img: 'orange.png',
                buryName: 'Orange',
            },
        ],
    },
    {
        categoryName: 'stylize',
        list: [
            {
                uniqueKey: 'stylize-verdant-realism',
                name: 'verdant-realism',
                value: 'verdant-realism',
                img: 'verdant-realism.png',
                buryName: 'Realism',
            },

            {
                uniqueKey: 'stylize-purple-glowing-illustration',
                name: 'purple-glowing-illustration',
                value: 'purple-glowing-illustration',
                img: 'purple-glowing-illustration.png',
                buryName: 'Glow Art',
            },
            {
                uniqueKey: 'stylize-purple-art',
                name: 'purple-art',
                value: 'purple-art',
                img: 'purple-art.png',
                buryName: 'Purple Art',
            },
            {
                uniqueKey: 'stylize-cyberpunk',
                name: 'cyberpunk',
                value: 'cyberpunk',
                img: 'cyberpunk.png',
                buryName: 'Cyberpunk',
            },
            {
                uniqueKey: 'stylize-metallic',
                name: 'metallic',
                value: 'metallic',
                img: 'metallic.png',
                buryName: 'Metallic',
            },
            {
                uniqueKey: 'stylize-horror-comics',
                name: 'horror-comics',
                value: 'horror-comics',
                img: 'horror-comics.png',
                buryName: 'Horror Comics',
            },
            {
                uniqueKey: 'stylize-golden-hour',
                name: 'golden-hour',
                value: 'golden-hour',
                img: 'golden-hour.png',
                buryName: 'Golden Hour',
            },
            {
                uniqueKey: 'stylize-dark-cyan',
                name: 'dark-cyan',
                value: 'dark-cyan',
                img: 'dark-cyan.png',
                buryName: 'Dark Cyan',
            },
            {
                uniqueKey: 'stylize-pop-art',
                name: 'pop-art',
                value: 'pop-art',
                img: 'pop-art.png',
                buryName: 'Pop Art',
            },
        ],
    },
    {
        categoryName: 'holiday',
        list: [
            {
                uniqueKey: 'holiday-christmas-1',
                name: 'christmas-1',
                value: 'christmas-1',
                img: 'christmas-1.png',
                buryName: 'Christmas 1',
            },
            {
                uniqueKey: 'holiday-christmas-2',
                name: 'christmas-2',
                value: 'christmas-2',
                img: 'christmas-2.png',
                buryName: 'Christmas 2',
            },
            {
                uniqueKey: 'holiday-christmas-3',
                name: 'christmas-3',
                value: 'christmas-3',
                img: 'christmas-3.png',
                buryName: 'Christmas 3',
            },
            {
                uniqueKey: 'holiday-christmas-4',
                name: 'christmas-4',
                value: 'christmas-4',
                img: 'christmas-4.png',
                buryName: 'Christmas 4',
            },
            {
                uniqueKey: 'holiday-halloween',
                name: 'halloween',
                value: 'halloween',
                img: 'halloween.png',
                buryName: 'Halloween',
            },
        ],
    },
];
export const MAX_GENERATE_NUM = 4;
export const MOBILE_PREVIEW_DATA = [
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'dog.mp4?v=' + FJConfig.version,
        title: '图片1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'people.mp4?v=' + FJConfig.version,
        title: '视频1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'architecture.mp4?v=' + FJConfig.version,
        title: '图片2',
    },
];
